/**
 * 鼠标移上去显示的独立小卡片（白底、左侧一道强调色），移植产品原型 components/HoverCard.tsx。
 * 卡片用 fixed 定位挂到 body 上，不会被表格的横向滚动容器裁掉。
 *
 * 与原型唯一的差别：zIndex 60 → 1100。原型的抽屉是自绘的 z-60，这里用的是 antd Drawer（z-index 1000），
 * 不抬高的话抽屉里的悬浮卡会被遮住。
 */
import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
    card: React.ReactNode;
    accent?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

const W = 340;

const HoverCard: React.FC<Props> = ({ card, accent = '#F53F3F', children, style, className }) => {
    const ref = React.useRef<HTMLSpanElement | null>(null);
    const [pos, setPos] = React.useState<{ x: number; y: number } | null>(null);

    const show = () => {
        const r = ref.current?.getBoundingClientRect();
        if (!r) return;
        const x = Math.min(Math.max(8, r.left), window.innerWidth - W - 12);
        // 空间不够就显示在上方
        const below = r.bottom + 8;
        const y = below + 190 > window.innerHeight ? Math.max(8, r.top - 8 - 190) : below;
        setPos({ x, y });
    };

    return (
        <span ref={ref} onMouseEnter={show} onMouseLeave={() => setPos(null)} className={className} style={style}>
            {children}
            {pos &&
                createPortal(
                    <div
                        style={{
                            position: 'fixed',
                            left: pos.x,
                            top: pos.y,
                            width: W,
                            zIndex: 1100,
                            background: '#fff',
                            border: '1px solid #E5E6EB',
                            borderLeft: `3px solid ${accent}`,
                            borderRadius: 4,
                            boxShadow: '0 6px 20px rgba(0,0,0,.14)',
                            padding: '9px 11px',
                            fontSize: 12.5,
                            lineHeight: 1.6,
                            color: '#4E5969',
                            pointerEvents: 'none',
                            textAlign: 'left',
                            fontWeight: 400,
                            whiteSpace: 'normal'
                        }}
                    >
                        {card}
                    </div>,
                    document.body
                )}
        </span>
    );
};

export default HoverCard;
